import { useEffect, useState } from 'react';
import api from '../../axios/axios';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { setPriceFilteredProducts } from '../../redux/product/productSlice';
import { useLocation } from 'react-router-dom';

const ProductTypes = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  
  // Get productType from query param
  const params = new URLSearchParams(location.search);
  const productTypeParam = params.get('productType');
  
  // Initialize state with query param if present, otherwise "All"
  const [productType, setProductType] = useState(productTypeParam || "All");

  // Get productTypeNames from Redux store (adjust path to match the correct structure)
  const productTypeNames = useSelector((state) => state.product.productFilterDetails.productsTypeNames);

  // Update productType state when query param changes
  useEffect(() => {
    if (productTypeParam) {
      setProductType(productTypeParam);
    } else {
      setProductType("All");
    }
  }, [productTypeParam]);

  // Handle change when selecting a product type
  const handleChange = (e) => {
    setProductType(e.target.value); // Update state on selection
  };

  // Fetch products based on selected product type
  useEffect(() => {
    fetchProductTypeProducts(productType);
  }, [productType]); // Dependency array ensures this effect runs on productType change

  const fetchProductTypeProducts = async (productType) => {
    try {
      const response = await api.get('user/productTypesProducts', {
        params: { productType }, // Pass productType as query parameter
      });

      // Ensure the response structure matches the expected one in your Redux slice
      dispatch(setPriceFilteredProducts({
        priceFilteredProducts: response.data
      }));

    } catch (error) {
      Swal.fire({ 
        title: 'Error',
        text: error.response?.data?.message || "There was an error fetching the products",
        icon: 'error',
        confirmButtonText: 'Try Again'
      });
    }
  };

  const formatProductType = (str) => {
    return str
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <div className="mb-6">
      <label htmlFor="filtering" className="text-gray-700 font-medium mr-4">
        Filter by:
      </label>
      <select
        id="filtering"
        value={productType}
        onChange={handleChange}
        className="p-3 border rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-green-500"
      >
        {/* Add 'All' as the first option */}
        <option value="All">All</option>

        {/* Check if productTypeNames is available and not empty */}
        {productTypeNames?.length ? (
          productTypeNames.map((type) => (
            <option key={type} value={type}>
              {formatProductType(type)} {/* Use formatProductType to display correctly */}
            </option>
          ))
        ) : (
          <option value="All" disabled>No product types available</option>
        )}
      </select>
    </div>
  );
};

export default ProductTypes;